//#region src/engine/modules/relationship/actions.ts
var ActionType = {
	addRelationship: "relationship.add",
	removeRelationship: "relationship.remove",
	changeRelationshipType: "relationship.changeType",
	changeRelationshipOnDelete: "relationship.changeOnDelete",
	changeRelationshipOnUpdate: "relationship.changeOnUpdate",
	changeRelationshipColumns: "relationship.changeColumns"
};
//#endregion
export { ActionType };
